import { Grid } from '@grupoboticario/flora-react';
import styled from 'styled-components';

export const Main = styled(Grid)`
  width: 100%;
  height: 100%;

  background-color: ${({ theme }) => theme.colors.background};

  grid-template-columns: repeat(3, 1fr);
  grid-gap: 20px;
  padding: 8px 45px;

  @media (min-width: 1920px) {
    grid-template-columns: 1fr 1.4fr 1.4fr;
  }
  @media (max-width: 1110px) {
    grid-template-columns: 1fr;
  }

  @media (max-width: 767px) {
    padding: 8px 20px 50px;
  }
`;
